export const GET_HELP_ALL_CATEGORY = '/api/help/get-all-help-categories';
export const GET__HELP_CATEGORY_DETAIL = '/api/help/get-category-detail';
export const GET_HELP_POST_DETAIL = '/api/help/get-help-post-data';
export const SEARCH_HELP_POSTS = '/api/help/search-help-posts';
export const SEARCH_HELP_AUTO_COMPLETE = '/api/help/get-autocomplete-data';
